import { render, staticRenderFns } from "./LabelNumberInput.vue?vue&type=template&id=3334918a&scoped=true&"
import script from "./LabelNumberInput.vue?vue&type=script&lang=js&"
export * from "./LabelNumberInput.vue?vue&type=script&lang=js&"
import style0 from "./LabelNumberInput.vue?vue&type=style&index=0&id=3334918a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3334918a",
  null
  
)

export default component.exports